import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import { HTMLAttributes, ReactElement } from "react";

const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 45],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
interface Props extends HTMLAttributes<HTMLElement> {
  myStyle?: string;
  latitude: number;
  longitude: number;
}
export function PersianMap({ myStyle, latitude, longitude }: Props): ReactElement {


  return (
    <>
      {latitude !== undefined && longitude !== undefined && (



        <MapContainer className={myStyle} center={[latitude, longitude]} zoom={16}
          style={{ height: "300px", width: "100%", position: "relative", zIndex: 0 }}
        >
          <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
          {/* 
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          */}

          <Marker position={[latitude, longitude]} icon={customIcon}>
            <Popup>فاز ۵ پردیس - تهران</Popup>
          </Marker>
        </MapContainer>
      )
      }
    </>
  );
};

export default PersianMap;
